export const SHOPIFY_DATA = {
    cardid: [],
    product: [],
    footer: [],
    click: [],
};

// Product is an object that contains the following attributes:
// * id
// * name
// * category_name
// * sku
// * variants
// * price
// * img_url
export function save_sghome_datalayer(product, ispromo, position, listname) {
    SHOPIFY_DATA.product.push({
        product,
        ispromo,
        position,
        listname,
    });
}

export function save_sghome_cardid(idlist) {
    let all_position_id = idlist.split(',');
    let cardid = SHOPIFY_DATA.cardid;
    cardid.push.apply(cardid, all_position_id);
}

// footer is an object that contains the following attributes:
// * id
// * name
// * img_url
// * position
//
// click is an object that contains the following attributes:
// * total
// * name
// * creative
// * position
export function save_sghome_footer_datalayer(footer, click) {
    SHOPIFY_DATA.footer.push({
        footer,
        click,
    });
}

// ispromo is a boolean
//
// promo is an object that contains the following attributes:
// * id
// * name
// * creative
// * position
//
// product is an object that contains the following attributes:
// * id
// * price
// * name
// * listname
// * position
export function save_sghome_click_datalayer(ispromo, promo, product) {
    SHOPIFY_DATA.click.push({
        ispromo,
        promo,
        product,
    });
}
